// extracted by css-extract-rspack-plugin
export default {"cls1":"highlightText-cls1_3tU","cls2":"highlightText-cls2_xyH highlightText-cls1_3tU"};